import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lottie from "lottie-react";

import visionAnim from "../lottie/vision.json";
import missionAnim from "../lottie/mission.json";

gsap.registerPlugin(ScrollTrigger);

const AboutScrollSection = () => {
  const aboutsRef = useRef();

  useEffect(() => {
    const ctx = gsap.context(() => {
   const mm = gsap.matchMedia();
   mm.add("(min-width: 991px)", () => {
  const tl = gsap.timeline({
      scrollTrigger: {
        trigger: aboutsRef.current,
        start: "top top",
        end: "+=1000",     // scroll length of story
        scrub: true,
        // pin: ".ab-scroll-sticky",
        anticipatePin: 1
      }
    });

// SPLIT FRAME (Webflow a-20-n)
tl.to(".mv-frame.is-left", {
  xPercent: -35,
  duration: 0.5,
  ease: "power2.inOut"
}, "<");

// SPLIT FRAME (Webflow a-20-n-3)
tl.to(".mv-frame.is-right", {
    xPercent: 35,
  duration: 0.5,
  ease: "power2.inOut"
}, "<");



gsap.to(".v-marquee.is-1", {
   yPercent: -50,
   repeat: -1,
   duration: 10,
   ease: "none",
 
});

gsap.to(".v-marquee.is-2", {
  yPercent: 50,
   repeat: -1,
  duration: 10,
  ease: "none",
  
});


tl.to(".v-marquee.is-1", {
   xPercent: -50,
    //  duration: 10,
   ease: "none",
 
});

tl.to(".mv-frame.is-right .is-2", {
  xPercent: -23,
    // duration: 10,
  ease: "none",
  
});

tl.to(".mv-img-wrapper.is-2", {
  xPercent: -99,
  duration: 0.5,
  ease: "power2.inOut"
});

// tl.to(".mv-img-wrapper.is-1", {
//   xPercent: 100,
//   duration: 0.5,
//   ease: "power2.inOut"
// });


// tl.to(".mv-img-wrapper.is-2", {
//   xPercent: -100,
//   duration: 0.5,
//   ease: "power2.inOut"
// });



gsap.set(".mv-img", {
  scale: 1.2,
  opacity: 0.2,
  yPercent: 0,
 width: "100%",
 height:"100vh"
});

tl.to(".mv-img", {
  scale: 1,
  opacity: 1,
  yPercent: 0,
  xPercent: 0
}, 0.3);


  tl.from(".values-wrapper", {
  scale: 0.6,
  opacity: 0,
  width: "100%",
  ease: "power2.out",
  duration: 0.1
}, 1.06);

tl.to(".values-marquee", {
   width: "100%",
  ease: "none",
}, 1.06);
   });


   mm.add("(max-width: 768px)", () => {
     const tl = gsap.timeline({
      scrollTrigger: {
        trigger: aboutsRef.current,
        start: "top top",
        end: "+3300",     // scroll length of story
        scrub: true,
        // pin: ".ab-scroll-sticky",
        anticipatePin: 1
      }
    });

// SPLIT FRAME (Webflow a-20-n)
tl.to(".mv-frame.is-left", {
  yPercent: -100,
  duration: 0.5,
  ease: "power2.inOut"
}, "<");

// SPLIT FRAME (Webflow a-20-n-3)
tl.to(".mv-frame.is-right", {
    yPercent: 100,
  duration: 0.5,
  ease: "power2.inOut"
}, "<");


gsap.to(".v-marquee.is-1", {
   yPercent: -50,
   repeat: -1,
   duration: 10,
   ease: "none",
 
});

gsap.to(".v-marquee.is-2", {
  yPercent: 50,
   repeat: -1,
  duration: 10,
  ease: "none",
  
});


tl.to(".v-marquee.is-1", {
   xPercent: -50,
    //  duration: 10,
   ease: "none",
 
});

tl.to(".mv-frame.is-right .is-2", {
  xPercent: -23,
    // duration: 10,
  ease: "none",
  
});

tl.to(".mv-img-wrapper.is-2", {
  xPercent: -99,
  duration: 0.5,
  ease: "power2.inOut"
});

   });

    }, aboutsRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={aboutsRef} className="about-scroll-section">
      <div className="ab-scroll-sticky">

        <div className="mv-wrapper">

          {/* LEFT — VISION */}
       <div className="mv-frame is-left">
                <div className="v-marquee is-1" >
                    <div className="v-m-wrap is-v">
                        <div className="v-marq-col">
                            <div className="h1-s-wrap v-marq">
                                <h1 className="h1-opac">vision</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                                <div className="mv-anim is-r">  <Lottie animationData={visionAnim}/></div>
                            </div>
                            <div className="h1-s-wrap v-marq">
                                <h1 className="h1-opac">vision</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                               <div className="mv-anim is-r">  <Lottie animationData={visionAnim}/></div>
                            </div>
                        </div>
                        <div className="v-marq-col">
                            <div className="h1-s-wrap v-marq">
                                <h1 className="h1-opac">vision</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                               <div className="mv-anim is-r">  <Lottie animationData={visionAnim}/></div>
                            </div>
                            <div className="h1-s-wrap v-marq">
                                <h1 className="h1-opac">vision</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                               <div className="mv-anim is-r">  <Lottie animationData={visionAnim}/></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mv-img-wrapper"
                   >
                    <div className="img-child">
                        <div className="mv-img is-v"></div>
                    </div>
                </div>
                <div className="mv-content-wrapper">
                    <div className="mv-text is-1">Our vision is To be our customer’s partner for everything Food Safe</div>
                </div>
            </div>

          {/* RIGHT — MISSION */}
        <div className="mv-frame is-right">
           
                <div className="mv-img-wrapper is-2"
                   >
                    <div className="img-child">
                        <div className="mv-img is-m"></div>
                    </div>
                </div>
                <div className="mv-content-wrapper is-2">
                    <div className="mv-text is-2">Engineering performance through hygiene, efficiency, and scalability is our mission</div>
                </div>

                     <div className="v-marquee is-2"
                   >
                    <div className="v-m-wrap is-m">
                        <div className="v-marq-col is-m">
                            <div className="h1-s-wrap m-marq">
                                <h1 className="h1-opac">Mission</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                                <div className="mv-anim is-r"> <Lottie animationData={missionAnim}/></div>
                            </div>
                            <div className="h1-s-wrap m-marq">
                                <h1 className="h1-opac">Mission</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                             <div className="mv-anim is-r"> <Lottie animationData={missionAnim}/></div>
                            </div>
                        </div>
                        <div className="v-marq-col is-m">
                            <div className="h1-s-wrap m-marq">
                                <h1 className="h1-opac">Mission</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                              <div className="mv-anim"> <Lottie animationData={missionAnim}/></div>
                            </div>
                            <div className="h1-s-wrap m-marq">
                                <h1 className="h1-opac">Mission</h1>
                            </div>
                            <div className="mv-anim-wrapper">
                               <div className="mv-anim"> <Lottie animationData={missionAnim}/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        {/* VALUES */}
        <div className="values-wrapper">

          <div className="h1-s-wrap is-values">
             <h1 className="h1-s stoke-special">Values</h1>
          </div>
         
          <div className="values-marquee">
           <div className="h-text-marquee is-values">
                <div className="h-text-marquee-wrapper">
                    <div className="h-text-marq-row">
                        {[
                          "HYGIENE-LED",
                          "CUSTOMER-CENTRIC",
                          "TRUSTWORTHY",
                          "WORLD CLASS",
                          "ACCOUNTABILITY",
                          "RELIABILITY",
                          "CONTINUOUS IMPROVEMENT",
                        ].map((v, i) => (
                          <><div  key={i} className='h-text-wrap'><div className='h-text is-value'>{v}</div> </div><div className='h-divider'></div></>
                        ))}
                        
                    </div>
                </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutScrollSection;